import { render, staticRenderFns } from "./quote-multi-parts.vue?vue&type=template&id=587ba20b&"
import script from "./quote-multi-parts.vue?vue&type=script&lang=js&"
export * from "./quote-multi-parts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports